const workercode = () => {
    let interval = 0;
    let terminate = 0;
    let reconnectTrial = 0;
    let intervalList = [];

    const TIMEOUT = 30000;
    const HB_SEND_INTERVAL = 10000;
    const WS_RECONNECT_INTERVAL = 3000;
    const MAX_RETRIES = 30;

    function setTimer() {
        terminate = setTimeout(() => {
            /**
             * Close the ws connection 
             * if server does not respond in 
             * 30 seconds, pings won't be sent
             */
            clearInterval(interval);
            postMessage('reconnect');
        }, TIMEOUT);
    }

    function connect(heartbeatInterval) {
        interval = setInterval(() => {
            postMessage('Send heartbeat')
        }, heartbeatInterval);
        intervalList.push(interval);
        setTimer();
    }

    self.onmessage = function(e) {
        switch(e.data) {
            case 'resetTimers':
                clearInterval(interval);
                clearTimeout(terminate);
                break;
            case 'reset':
                clearInterval(interval);
                clearTimeout(terminate);
                postMessage('terminate');
                break;
            case 'start':
                connect(HB_SEND_INTERVAL);
                break;
            case "resetTimeout":
                clearTimeout(terminate);
                
                // reset reconnection count as ACK has been received
                reconnectTrial = 0;
                // set new timeout for last heartbeat ack
                setTimer();
                break;
            case 'reconnect':
                reconnectTrial++;

                // retry count is 30 for 90 seconds
                if (reconnectTrial <= MAX_RETRIES) {
                    connect(WS_RECONNECT_INTERVAL);
                } else {
                    postMessage('terminate')
                }
                break;
            default:
                break;
        }
    }
};

let code = workercode.toString();
code = code.substring(code.indexOf("{")+1, code.lastIndexOf("}"));

const blob = new Blob([code], {type: "application/javascript"});
const worker_script = URL.createObjectURL(blob);

export { worker_script };